<template>
    <div>
        <popup
            v-model="open"
            :content-class="$style['popup-content']"
            @close="close"
        >
            <template #close-button="{ close: cl }">
                <div :class="$style['close-button']" @click="cl()">&times;</div>
            </template>
            <div :class="$style['inner-popup-content']">
                <div :class="$style['inner-popup-upper-text']">
                    {{ message }}
                </div>
                <br />
                <div :class="$style['buttons']">
                    <template v-for="link in links">
                        <div :class="$style['button-item']">
                            <cool-button size="large">
                                <a
                                    :href="link.link"
                                    :class="$style['button']"
                                    >{{ link.text }}</a
                                >
                            </cool-button>
                        </div>
                    </template>
                </div>
            </div>
        </popup>
    </div>
</template>

<style module>
.popup-content {
    border-radius: 16px;
    padding: 40px !important;
    max-width: 400px;
    min-height: 200px;
    background-color: black;
    color: white;
}

.inner-popup-upper-text {
    font-size: 23px;
    text-align: center;
    font-weight: 600;
    word-wrap: break-word;
}

.buttons {
    font-size: 16px;
}

.button-item {
    text-align: center;
    word-wrap: break-word;
}

.button-item + .button-item {
    margin-top: 1em;
}

.button {
    background-color: rgb(29, 182, 180) !important;
    display: block !important;
}

.close-button {
    font-size: 30px;
    line-height: 0;
    font-weight: 600;
    cursor: pointer;
    padding: 24px 17px;
}
</style>

<script setup lang="ts">
import { type PropType, ref } from "vue";
import popup from "../header/appearance-containers/modal/modal.vue";
import CoolButton from "../shared/CoolButton.vue";
defineProps({
    message: {
        type: String,
        required: true,
    },
    links: {
        type: Array as PropType<{ link: string; text: string }[]>,
        required: true,
    },
});
const open = ref(true);
function close() {
    //this.$el.remove();
    //this.$destroy();
}
</script>
